import GridLayout from "components/GridLayout";
import { useTranslation } from "react-i18next";
import Section from "components/Section";
import Banner from "components/Banner";
import Header from "components/Header";
import Layout from "components/Layout";
import Image from "next/image";
import Link from "next/link";

import videoConferenceTeaching from "public/images/593x395/videoconference-teaching.png";
import discussionProject from "public/images/593x395/discussion-project.png";
import groupApplause from "public/images/593x395/group-applause.png";
import womenRobotics from "public/images/593x395/women-robotics.png";
import meetingImage from "public/images/593x395/meeting.png";
import family from "public/images/593x395/family.png";

import happyCoach from "public/images/happy-coach.png";

import ArrowedButtonLink from "components/ArrowedButtonLink";
import BicoloredTitle from "components/BicoloredTitle";
import GridList from "components/GridList";

export default function CoachingPage() {
  const { t } = useTranslation();

  return (
    <Layout>
      <Header
        className="bg-[url('/images/persons/marie-helene-demers.png')]"
        title={t("business_coaching")}
      />
      <main>
        <Banner
          title={t("coaching_page.banner.subtitle") || ""}
          text={t("coaching_page.banner.paragraph") || ""}
          color="green"
        />
        <div className="bg-pink-salt">
          <Section className="bg-pink-salt py-20">
            <GridLayout className="items-start">
              <article className="space-y-5 text-neutral-600">
                <BicoloredTitle
                  subtitle={t(
                    "coaching_page.first_section.colored_title.subtitle"
                  )}
                  primary={t(
                    "coaching_page.first_section.colored_title.colored"
                  )}
                  secondary={t(
                    "coaching_page.first_section.colored_title.regular"
                  )}
                  primaryColor="green"
                />
                <p className="pg-3xl font-bold">
                  {t("coaching_page.first_section.bold_paragraph")}
                </p>
                <p className="pg-2xl">
                  {t("coaching_page.first_section.first_paragraph")}
                </p>
                <p className="pg-2xl">
                  {t("coaching_page.first_section.second_paragraph")}
                </p>
              </article>
              <article className="flex flex-col">
                <iframe
                  className="mx-auto w-full rounded-lg h-[315px] max-w-[560px]"
                  src="https://www.youtube.com/embed/remEeJJwVSg"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
                <div className="py-8 px-10 mt-12 w-full flex flex-col border-green-500 border rounded-lg">
                  <h4 className="mx-auto text-center text-green-500 font-bold text-r-3xl mb-8 whitespace-pre-line">
                    {t("coaching_page.first_section.list_title")}
                  </h4>
                  <ul className="grid grid-cols-1 xs:grid-cols-2 gap-8">
                    {(
                      (t("coaching_page.first_section.list", {
                        returnObjects: true,
                      }) as string[]) || []
                    ).map((item) => (
                      <li
                        key={item}
                        className="flex items-center text-neutral-600 font-bold text-r-lg leading-1.2"
                      >
                        <svg
                          className="mr-3 min-w-[17px] min-h-[16px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M11.7135 7.38462C12.1238 7.38462 12.3289 7.58974 12.3289 8C12.3289 8.41026 12.1238 8.61539 11.7135 8.61539H8.86734V11.4615C8.86734 11.8718 8.66221 12.0769 8.25195 12.0769C7.84169 12.0769 7.63657 11.8718 7.63657 11.4615V8.61539H4.79041C4.38016 8.61539 4.17503 8.41026 4.17503 8C4.17503 7.58974 4.38016 7.38462 4.79041 7.38462H7.63657V4.53846C7.63657 4.1282 7.84169 3.92308 8.25195 3.92308C8.66221 3.92308 8.86734 4.1282 8.86734 4.53846V7.38462H11.7135ZM13.1366 3.11538C11.7776 1.7564 10.1494 1.07692 8.25195 1.07692C6.35451 1.07692 4.72632 1.7564 3.36734 3.11538C2.00836 4.47437 1.32888 6.10255 1.32888 8C1.32888 9.89745 2.00836 11.5256 3.36734 12.8846C4.72632 14.2436 6.35451 14.9231 8.25195 14.9231C10.1494 14.9231 11.7776 14.2436 13.1366 12.8846C14.4955 11.5256 15.175 9.89745 15.175 8C15.175 6.10255 14.4955 4.47437 13.1366 3.11538ZM2.59811 2.34615C4.16222 0.782044 6.04681 0 8.25195 0C10.4571 0 12.3417 0.782044 13.9058 2.34615C15.4699 3.91026 16.252 5.79486 16.252 8C16.252 10.2051 15.4699 12.0897 13.9058 13.6538C12.3417 15.218 10.4571 16 8.25195 16C6.04681 16 4.16222 15.218 2.59811 13.6538C1.034 12.0897 0.251953 10.2051 0.251953 8C0.251953 5.79486 1.034 3.91026 2.59811 2.34615Z"
                            fill="#759963"
                          />
                        </svg>
                        <p>{item}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </GridLayout>
            <article className="mt-20">
              <h3 className="text-r-5xl font-bold text-neutral-600">
                {t("coaching_page.first_section.services_title")}
              </h3>
              <ul className="text-r-2xl mt-10 flex flex-wrap justify-center gap-7 text-center font-bold">
                {(
                  (t("coaching_page.first_section.services", {
                    returnObjects: true,
                  }) as { name: string; id: string }[]) || []
                ).map(({ name, id }) => (
                  <div key={id} className="w-full md:basis-1/4">
                    <li className="mx-auto flex h-[150px] w-full xs:w-[387px] flex-col justify-center gap-2.5 rounded-lg border-[1px] border-green-300 bg-white px-4">
                      <p className="text-balance">{name}</p>
                      <Link
                        className="text-r-base text-blue hover:underline"
                        href={`#${id}`}
                      >
                        {t("coaching_page.first_section.explore_service")}
                      </Link>
                    </li>
                  </div>
                ))}
              </ul>
            </article>
          </Section>
        </div>
        <Section className="space-y-24 xl:space-y-48 py-20 text-neutral-600">
          <GridLayout id="organizational_transformation" className="items-end">
            <div className="flex flex-col gap-8">
              <BicoloredTitle
                textSize="6xl"
                primary={t(
                  "coaching_page.second_section.colored_title.colored"
                )}
                secondary={t(
                  "coaching_page.second_section.colored_title.regular"
                )}
                primaryColor={"green"}
              />
              <p className="pg-3xl">
                {t("coaching_page.second_section.first_paragraph")}
              </p>
              <Image
                src={meetingImage}
                alt="meeting"
                width={593}
                height={395}
              />
            </div>
            <div className="mb-8 space-y-8 leading-1.1 flex flex-col items-start">
              <div>
                <h5 className="text-r-2xl leading-1.1 font-bold">
                  {t("coaching_page.second_section.second_title")}
                </h5>
                <p className="text-r-xl leading-1.1 mt-4">
                  {t("coaching_page.second_section.second_paragraph")}
                </p>
              </div>
              <GridList
                className="w-full"
                list={
                  (t("coaching_page.second_section.list", {
                    returnObjects: true,
                  }) as string[]) || []
                }
              />
              <p className="text-r-xl leading-1.1">
                {t("coaching_page.second_section.third_paragraph")}
              </p>
              <ArrowedButtonLink
                className="py-4"
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                text={t("contact_us")}
              />
            </div>
          </GridLayout>
          <GridLayout id="executive_coaching" gap={8}>
            <div className="flex flex-col items-start gap-5">
              <BicoloredTitle
                textSize="6xl"
                primary={t("coaching_page.third_section.colored_title.colored")}
                secondary={t(
                  "coaching_page.third_section.colored_title.regular"
                )}
                primaryColor={"green"}
              />
              <p className="pg-3xl">
                {t("coaching_page.third_section.first_paragraph")}
              </p>
              <p className="pg-2xl mt-2">
                {t("coaching_page.third_section.second_paragraph")}
              </p>
              <p className="pg-2xl mt-2">
                {t("coaching_page.third_section.third_paragraph")}
              </p>
              <ArrowedButtonLink
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                className="mt-4 py-4"
                text={t("contact_us")}
              />
            </div>
            <div className="flex flex-col items-start">
              <Image
                className="mb-10"
                src={discussionProject}
                alt="Persons discussing a project"
                width={593}
                height={395}
              />
              <div className="space-y-4">
                <h4 className="pg-3xl font-bold">
                  {t("coaching_page.third_section.second_title")}
                </h4>
                <p className="pg-2xl">
                  {t("coaching_page.third_section.fourth_paragraph")}
                </p>
              </div>
            </div>
          </GridLayout>
          <GridLayout
            id="culture_team"
            className="items-start xl:items-center"
            gap={8}
          >
            <div className="items-start flex flex-col">
              <BicoloredTitle
                textSize="6xl"
                primary={t(
                  "coaching_page.fourth_section.colored_title.colored"
                )}
                secondary={t(
                  "coaching_page.fourth_section.colored_title.regular"
                )}
                primaryColor={"green"}
              />
              <div className="mb-4 mt-11 space-y-5">
                <h4 className="pg-3xl font-bold">
                  {t("coaching_page.fourth_section.second_title")}
                </h4>
                <p className="pg-2xl">
                  {t("coaching_page.fourth_section.first_paragraph")}
                </p>
                <p className="pg-2xl">
                  {t("coaching_page.fourth_section.second_paragraph")}
                </p>
              </div>
              <ArrowedButtonLink
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                className="mt-5 py-4"
                text={t("contact_us")}
              />
            </div>
            <div>
              <Image
                className="mt-8"
                src={groupApplause}
                alt="Team applauding"
                width={593}
                height={395}
              />
            </div>
          </GridLayout>
          <GridLayout id="performance_talent" className="items-end" gap={8}>
            <div>
              <BicoloredTitle
                textSize="6xl"
                primary={t("coaching_page.fifth_section.colored_title.colored")}
                secondary={t(
                  "coaching_page.fifth_section.colored_title.regular"
                )}
                primaryColor={"green"}
              />
              <p className="pg-3xl mb-2 mt-4 md:mt-8">
                {t("coaching_page.fifth_section.first_paragraph")}
              </p>
              <Image
                className="mt-4"
                src={womenRobotics}
                alt="Person doing robotics"
                width={593}
                height={395}
              />
            </div>
            <div className="flex flex-col items-start">
              <p className="text-r-xl leading-1.1 mt-6">
                {t("coaching_page.fifth_section.second_paragraph")}
              </p>
              <div className="mb-6 mt-4 space-y-4">
                <h4 className="text-r-2xl leading-1.2 font-bold">
                  {t("coaching_page.fifth_section.second_title")}
                </h4>
                <p className="text-r-xl leading-1.1">
                  {t("coaching_page.fifth_section.third_paragraph")}
                </p>
              </div>
              <GridList
                list={
                  (t("coaching_page.fifth_section.list", {
                    returnObjects: true,
                  }) as string[]) || []
                }
              />
              <ArrowedButtonLink
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                className="mt-11 py-4"
                text={t("contact_us")}
              />
            </div>
          </GridLayout>
          <GridLayout
            id="it_profesionnals_coaching"
            className="items-start xl:items-center"
            gap={8}
          >
            <div className="flex flex-col items-start">
              <BicoloredTitle
                textSize="6xl"
                primary={t("coaching_page.sixth_section.colored_title.colored")}
                secondary={t(
                  "coaching_page.sixth_section.colored_title.regular"
                )}
                primaryColor={"green"}
              />
              <p className="pg-3xl mt-8">
                {t("coaching_page.sixth_section.first_paragraph")}
              </p>
              <div className="mb-6 mt-8 space-y-4">
                <h4 className="text-r-2xl leading-1.1 font-bold">
                  {t("coaching_page.sixth_section.second_title")}
                </h4>
                <p className="text-r-xl leading-1.1">
                  {t("coaching_page.sixth_section.second_paragraph")}
                </p>
              </div>
              <ArrowedButtonLink
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                className="mb-5 py-4"
                text={t("contact_us")}
              />
            </div>
            <div>
              <Image
                className="mt-5"
                src={videoConferenceTeaching}
                alt="Person looking a teacher doing a course in videoconference"
                width={593}
                height={395}
              />
            </div>
          </GridLayout>
          <GridLayout
            id="diversity_equity_inclusion"
            className="items-start xl:items-end"
            gap={8}
          >
            <div className="flex flex-col items-start">
              <BicoloredTitle
                textSize="6xl"
                primary={t(
                  "coaching_page.seventh_section.colored_title.colored"
                )}
                secondary={t(
                  "coaching_page.seventh_section.colored_title.regular"
                )}
                primaryColor={"green"}
              />
              <p className="pg-3xl mt-8">
                {t("coaching_page.seventh_section.first_paragraph")}
              </p>
              <p className="text-r-xl leading-1.1 mt-8">
                {t("coaching_page.seventh_section.second_paragraph")}
              </p>
              <p className="text-r-xl leading-1.1 mt-4">
                {t("coaching_page.seventh_section.third_paragraph")}
              </p>
              <ArrowedButtonLink
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                className="mt-8 lg:mt-14 py-4"
                text={t("contact_us")}
              />
            </div>
            <div>
              <Image
                className="mb-11"
                src={family}
                alt="Family of four smiling"
                width={593}
                height={395}
              />
            </div>
          </GridLayout>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-0 rounded-lg bg-neutral-700 text-white">
            <Image
              className="h-full max-h-[500px] xl:max-h-none w-full rounded-bl-none rounded-tr-lg xl:rounded-tr-none xl:rounded-bl-lg rounded-tl-lg object-cover object-center"
              src={happyCoach}
              alt={"Coach smiling"}
            />
            <div className="flex flex-col py-10 items-start px-14 my-auto">
              <h3 className="text-green-100 leading-none max-w-[18ch] text-r-4xl">
                {t("coaching_page.eigth_section.title.first")}
                <br />
                <span className="text-r-6xl ">
                  {t("coaching_page.eigth_section.title.second")}
                </span>
              </h3>
              <p className="mt-3 text-r-2xl leading-1.2">
                {t("coaching_page.eigth_section.paragraph")}
              </p>
              <ArrowedButtonLink
                rel="noreferrer"
                target="_blank"
                href={t("coaching_page.cta_url")}
                className="mt-8"
                variant="secondary"
                text={t("coaching_page.eigth_section.cta")}
              />
            </div>
          </div>
        </Section>
        <div className="mt-16 bg-[url('/images/men-sitting-smiling.jpeg')] bg-[70%] lg:bg-top bg-cover bg-no-repeat">
          <Section className="mb-12 py-[72px] 2xl:py-[200px] md:mb-10">
            <GridLayout breakpoint="lg">
              <div className="flex flex-col items-start mb-6 mt-[500px] rounded-lg bg-white px-5 py-8 sm:mt-[600px] lg:mb-0 lg:mt-0 lg:py-20">
                <p className="font-bold text-r-3xl leading-1.2">
                  {t("coaching_page.ninth_section.title")}
                </p>
                <p className="text-r-3xl leading-1.2">
                  {t("coaching_page.ninth_section.first_paragraph")}
                </p>
                <p className="text-r-2xl py-8">
                  {t("coaching_page.ninth_section.second_paragraph")}
                </p>
                <ArrowedButtonLink
                  rel="noreferrer"
                  target="_blank"
                  href={
                    "https://lp.afiexpertise.com/contactez-nous-afi-par-edgenda"
                  }
                  text={t("coaching_page.ninth_section.cta")}
                />
              </div>
            </GridLayout>
          </Section>
        </div>
      </main>
    </Layout>
  );
}
